import React, { useEffect, useState } from 'react';
import img1 from "../img/main-page/1.png"
import img2 from "../img/main-page/2.png"
import img3 from "../img/main-page/3.png"
import img4 from "../img/main-page/4.png"
import img5 from "../img/main-page/3.png"
import img6 from "../img/jp/jp1.png"
import img7 from "../img/jp/jp2.png"
import img8 from "../img/jp/jp3.png"
import coach1 from '../img/coach/coac3.png'
import coach2 from '../img/coach/coac1.png'
import coach3 from '../img/coach/coac2.png'
import coach4 from '../img/coach/coac4.png'
import coach5 from '../img/coach/coac2.png'

const Banner = ({maya, japanese, coach}) => {
    const featuredProducts = maya? [img6,img7,img8] : japanese? [img6,img7,img8] :coach? [coach1,coach2,coach3,coach4,coach5] : [img1,img2,img3,img4,img5];

    //   console.log(state[1].poa);
    let count = 0;
    let slideInterval;
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        startSlider();
        return () => {
            pauseSlider();
        };
    }, []);
    const startSlider = () => {
        slideInterval = setInterval(() => {
            // handleOnNextClick();
            count = (count + 1) % featuredProducts.length;
            setCurrentIndex(count);
        }, 5000);
    };

    const pauseSlider = () => {
        clearInterval(slideInterval);
    };
    return (
        <div>
            <div>
            <img className={`${maya?'h-[50vh] w-full':'h-auto lg:h-[66vh] w-full'} ${japanese && 'lg:h-[60vh] h-auto my-5'}`} src={featuredProducts[currentIndex]} alt="" />
            </div>
        </div>
    );
};

export default Banner;
